import React from 'react';
import { createPortal } from 'react-dom';
import MagicButton from 'components/MagicButton/MagicButton';
import { AssetUrls } from 'config/assets';
import { CronJobType } from 'types/interfaces/cronjob';
import './ConfirmJobTriggerModal.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  jobType: CronJobType | null;
  isLoading?: boolean;
}

const ConfirmJobTriggerModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  jobType,
  isLoading = false
}) => {
  if (!isOpen || !jobType) return null;

  const modalContent = (
    <div className="confirm-job-modal-overlay" onClick={onClose}>
      <div className="confirm-job-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-job-modal-header">
          <h2 className="confirm-job-modal-title">Confirm Manual Job Execution</h2>
          <button className="confirm-job-close-button" onClick={onClose}>
            <img
              src={AssetUrls.icons.dropdowns.close}
              alt="Close"
              style={{ width: 16, height: 16 }}
            />
          </button>
        </div>

        <div className="confirm-job-modal-content">
          <p className="confirm-question">Are you sure you want to manually run:</p>
          <h3 className="job-display-name">{jobType.display}</h3>
          <p className="job-description">{jobType.description}</p>

          <div className="warning-box">
            ⚠️ <strong>Normal Schedule:</strong> {jobType.schedule}
          </div>

          <p className="warning-text">
            This will start the job immediately in the background.
          </p>
        </div>

        <div className="confirm-job-modal-footer">
          <MagicButton
            label="Cancel"
            color="grey"
            onPress={onClose}
            isDisabled={isLoading}
            fullWidth={false}
          />
          <MagicButton
            label={isLoading ? "Starting Job..." : "Run Job Now"}
            color="purple"
            onPress={onConfirm}
            isLoading={isLoading}
            isDisabled={isLoading}
            fullWidth={false}
          />
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ConfirmJobTriggerModal;
